import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { saveEnquiry } from "../functions/Enquiry";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    try {
      // Prepare data in the expected structure for saveEnquiry
      const formData = {
        contactInfo: {
          name: form.name,
          email: form.email,
          phone: form.phone,
        },
        message: form.message,
      };
      const result = await saveEnquiry(formData);
      if (result.success) {
        setSubmitted(true);
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        setErrorMsg(result.message || "Failed to send enquiry.");
      }
    } catch (err) {
      setErrorMsg("Failed to send enquiry.");
    } finally {
      setLoading(false);
    }
  };

  // Theme color variables (fallbacks for SSR)
  const primary = "var(--primary-color, #afc15a)";
  const secondary = "var(--secondary-color, #ff6b35)";
  const darkBg = "var(--dark-bg, #121212)";
  const darkText = "var(--dark-text, #e0e0e0)";

  return (
    <>
      <Header />
      <main
        style={{
          minHeight: "70vh",
          background: darkBg,
          paddingTop: 48,
          paddingBottom: 48,
        }}
      >
        <div
          style={{
            maxWidth: 900,
            margin: "0 auto",
            background: "#181818",
            borderRadius: 18,
            boxShadow: "0 4px 32px rgba(175,193,90,0.10)",
            display: "flex",
            flexWrap: "wrap",
            overflow: "hidden",
            color: darkText,
          }}
        >
          {/* Left: Contact Info */}
          <div
            style={{
              flex: "1 1 320px",
              minWidth: 280,
              background: `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)`,
              color: "#fff",
              padding: "40px 32px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 24,
            }}
          >
            <h2 style={{ fontWeight: 700, fontSize: 28, marginBottom: 8 }}>
              Get in Touch
            </h2>
            <p style={{ fontSize: 16, opacity: 0.95 }}>
              We'd love to hear from you! Reach out for any queries, suggestions, or
              partnership opportunities.
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: 22 }}>
                <i className="fa-solid fa-envelope"></i>
              </span>
              <span style={{ fontSize: 16 }}>bookings@travelscapetours.com</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: 22 }}>
                <i className="fa-solid fa-phone"></i>
              </span>
              <span style={{ fontSize: 16 }}>+91 8799982010</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                marginTop: 16,
              }}
            >
              <a
                href="#"
                style={{ color: "#fff", fontSize: 20 }}
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
            <div
              style={{
                marginTop: 32,
                fontSize: 13,
                opacity: 0.8,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <i className="fa-solid fa-location-dot" style={{ marginRight: 8 }}></i>
              Mumbai
            </div>
          </div>
          {/* Right: Contact Form */}
          <div
            style={{
              flex: "2 1 400px",
              minWidth: 320,
              padding: "40px 32px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              background: "#232323",
              color: darkText,
            }}
          >
            <h3 style={{ color: primary, fontWeight: 600, marginBottom: 18 }}>
              Contact Form
            </h3>
            {submitted ? (
              <div
                style={{
                  color: primary,
                  margin: "20px 0",
                  background: "#232323",
                  border: `1px solid ${primary}`,
                  padding: 20,
                  borderRadius: 8,
                  textAlign: "center",
                  fontSize: 18,
                  fontWeight: 500,
                }}
              >
                <i className="fa-solid fa-circle-check" style={{ fontSize: 24, marginRight: 8 }}></i>
                Thank you for contacting us! We'll get back to you soon.
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 18,
                }}
              >
                <div>
                  <label style={{ color: primary, fontWeight: 500, marginBottom: 6, display: "block" }}>
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    placeholder="Your Name"
                    style={{
                      width: "100%",
                      padding: 12,
                      borderRadius: 6,
                      border: `1px solid ${primary}`,
                      fontSize: 16,
                      outline: "none",
                      marginBottom: 2,
                      background: "#181818",
                      color: darkText,
                    }}
                  />
                </div>
                <div style={{ display: "flex", gap: 16 }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ color: primary, fontWeight: 500, marginBottom: 6, display: "block" }}>
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      placeholder="you@email.com"
                      style={{
                        width: "100%",
                        padding: 12,
                        borderRadius: 6,
                        border: `1px solid ${primary}`,
                        fontSize: 16,
                        outline: "none",
                        marginBottom: 2,
                        background: "#181818",
                        color: darkText,
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ color: primary, fontWeight: 500, marginBottom: 6, display: "block" }}>
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      required
                      placeholder="Your Phone Number"
                      style={{
                        width: "100%",
                        padding: 12,
                        borderRadius: 6,
                        border: `1px solid ${primary}`,
                        fontSize: 16,
                        outline: "none",
                        marginBottom: 2,
                        background: "#181818",
                        color: darkText,
                      }}
                    />
                  </div>
                </div>
                <div>
                  <label style={{ color: primary, fontWeight: 500, marginBottom: 6, display: "block" }}>
                    Message
                  </label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows={5}
                    placeholder="Type your message here..."
                    style={{
                      width: "100%",
                      padding: 12,
                      borderRadius: 6,
                      border: `1px solid ${primary}`,
                      fontSize: 16,
                      outline: "none",
                      resize: "vertical",
                      marginBottom: 2,
                      background: "#181818",
                      color: darkText,
                    }}
                  />
                </div>
                {errorMsg && (
                  <div style={{ color: secondary, marginBottom: 8, fontWeight: 500 }}>
                    {errorMsg}
                  </div>
                )}
                <button
                  type="submit"
                  style={{
                    padding: "14px 0",
                    background: primary,
                    color: "#232323",
                    border: "none",
                    borderRadius: 6,
                    fontWeight: 600,
                    fontSize: 17,
                    cursor: loading ? "not-allowed" : "pointer",
                    boxShadow: "0 2px 8px rgba(175,193,90,0.08)",
                    transition: "background 0.2s",
                    opacity: loading ? 0.7 : 1,
                  }}
                  disabled={loading}
                  onMouseOver={e => (e.target.style.background = secondary)}
                  onMouseOut={e => (e.target.style.background = primary)}
                >
                  <i className="fa-solid fa-paper-plane" style={{ marginRight: 8 }}></i>
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Contact;